allow-visible-on-all-workspaces:
  title: Cross-Space Visibility
  description: Allow the window to be visible on all workspaces, macOS only.
spotlight:
  errors:
    unknown: Unknown error
    prefix: 'Something went wrong: {message}'
    shortcutRegistrationFailed: 'Something went wrong: failed to register Spotlight shortcut.'
pages:
  modules:
    mcp-server:
      description: Connect and manage MCP server and tools
      title: MCP Server
  system:
    sections:
      section:
        window-shortcuts:
          title: Keyboard Shortcuts
    window-shortcuts:
      description: Modify the window shortcuts.
      title: Window Shortcuts
      empty: Not set
      spotlight:
        title: Spotlight shortcut
        description: Click the shortcut, then press a new shortcut. Press Esc to cancel.
      actions:
        recording: Press keys
        reset: Reset
      errors:
        load: Failed to load shortcut
        conflict: Shortcut already in use.
        failed: Failed to update shortcut
        requiresModifier: Use at least one of Cmd, Ctrl, Alt, or Super.
      toggle-move:
        label: Toggle Move
      toggle-resize:
        label: Toggle Resize
      toggle-ignore-mouse-event:
        label: Toggle Ignore Mouse Event
      press-keys: Press Keys...
    developer:
      sections:
        section:
          use-window-mouse:
            title: useWindowMouse Tool
            description: Test the Electron window cursor position
devtools:
  title: Developer
  pages:
    context-flow:
      title: Context Flow
    lag-visualizer:
      title: Lag Visualizer
    performance-visualizer:
      title: Performance Visualizer
      description: Toggle FPS/long task/memory overlay
    markdown-stress:
      title: Markdown Stress
      description: Stress markdown parsing and rendering with heavy chat payloads
    io-tracer:
      title: IO Tracer
    widgets-calling:
      title: Widget Calling

screen-capture:
  permissions-prompt:
    title: Screen Capture
    description: To capture screens or windows, screen and system audio recording permissions are required.
    open-preferences: Open System Preferences
    dismiss: Dismiss
    instructions:
      step-1: Open "System Preferences", select "Privacy & Security" from the sidebar.
      step-2: In the "Screen & System Audio Recording" and "System Audio Recording Only" sections, turn on the switches for Life.
      step-2-note: If Life is not listed, please add it manually by clicking the "+" button and selecting Life from the Applications folder.
